import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { NgIf } from "@angular/common";
import { CommonModule } from "@angular/common";
import { FormacaoComponent } from "../formacao/formacao.component";
import { CursosComponent } from "../cursos/cursos.component";
import { Subscription } from "rxjs";
import { IdiomaService } from "../../services/idioma.service";
import { TraducaoService } from "../../services/traducao.service";
import { RouterLink } from "@angular/router";


@Component({
  selector: 'app-principal',
  standalone: true,
  imports: [
    NgIf,
    CommonModule,
    FormacaoComponent,
    CursosComponent,
    RouterLink
  ],
  templateUrl: './principal.component.html',
  styleUrl: './principal.component.css'
})

export class PrincipalComponent implements OnInit, OnDestroy {
  telaAtiva: 'principal' | 'cursos' | 'formacao' = 'principal';

  cursosLabel: string = '';
  formacaoLabel: string = '';

  private subscriptions: Subscription[] = [];

  @HostBinding('class.show') show: boolean = false;

  constructor(
    private idiomaService: IdiomaService,
    private traducaoService: TraducaoService
  ) {}

  ngOnInit(): void {
    setTimeout(():void => {
      this.show = true;
    });
    this.subscriptions.push(
      this.idiomaService.idioma$.subscribe(idioma => {
        this.subscriptions.push(
          this.traducaoService.obterTraducao('cursos').subscribe({
            next: traducao => this.cursosLabel = traducao,
            error: err => console.error('Erro ao obter tradução para Cursos:', err)
          })
        );
        this.subscriptions.push(
          this.traducaoService.obterTraducao('formacao').subscribe({
            next: traducao => this.formacaoLabel = traducao,
            error: err => console.error('Erro ao obter tradução para Formação:', err)
          })
        );
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  alternarTela(tela: 'principal' | 'cursos' | 'formacao'): void {
    this.telaAtiva = tela;
  }

  voltarHome(): void {
    this.telaAtiva = 'principal';
  }
}
